const theme = {
    colors: {
      primary: '#007bff',
      dark: '#343a40',    
      light: '#f8f9fa',  
      danger: '#dc3545',  
      textTitle: '#78350F',
      darkBlue: '#0F172A',
      navBarBg: '#FFFBEC',
      yellowColor: '#FDE68A'
    }
  };
  
  export default theme;
  